import { render, staticRenderFns } from "./RxPaster.vue?vue&type=template&id=7f9c3e91&scoped=true&"
import script from "./RxPaster.vue?vue&type=script&lang=js&"
export * from "./RxPaster.vue?vue&type=script&lang=js&"
import style0 from "./RxPaster.vue?vue&type=style&index=0&id=7f9c3e91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c3e91",
  null
  
)

export default component.exports